import { Label } from './common/label'
import { useForm } from './form'

export const FormSimpleFloat = ({ name, label, required, hidden, readonly }) => {
  const { register } = useForm(name, { required, valueAsFloat: true, shouldDirty: true })

  return (
    <Label name={name} label={label} required={required} hidden={hidden}>
      <input className={`form-control ${readonly && 'bg-secondary-subtle'}`} type="numnber" step={0.1} {...register()} readOnly={readonly} />
    </Label>
  )
}
